import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import useMessagesTabs from './hooks/useMessagesTabs';
import CommonTabs, { TABS_APPEARANCE } from '../../components/common-tabs/CommonTabs';
import CommonTabPanel from '../../components/common-tabs/CommonTabPanel';
import Generate from './generate/Generate';
import Adjust from './adjust/Adjust';
import { changeMessagesTab } from '../../redux/activ8/activ8MessagesReducer';
import { ACTIV8_MESSAGE_TABS } from '../../constants';

import scss from './Message.module.scss';

function Messages() {
  const dispatch = useDispatch();
  const TABS = useMessagesTabs();

  const messagesTab = useSelector((state) => state.activ8Messages.messagesTab);

  const handleChangeTabs = (_, newTab) => {
    dispatch(changeMessagesTab(newTab));
  };

  return (
    <div>
      <CommonTabs
        tabs={TABS}
        value={messagesTab}
        onChange={handleChangeTabs}
        isContainerFullWidth={false}
        appearance={TABS_APPEARANCE.FILLED}
      />

      <CommonTabPanel value={messagesTab} index={ACTIV8_MESSAGE_TABS.GENERATE} className={scss.tabPanelWrapper}>
        <Generate />
      </CommonTabPanel>

      <CommonTabPanel value={messagesTab} index={ACTIV8_MESSAGE_TABS.ADJUST} className={scss.tabPanelWrapper}>
        <Adjust />
      </CommonTabPanel>
    </div>
  );
}

export default Messages;
